import { startRetryTimer } from "../log-queue/start-retry-timer.js";
import { logToIDB } from "./log-to-idb.js";
import { stringifyArgs } from "./stringify-args.js";

const logFunctions = {
  debug: window.console.debug,
  error: window.console.error,
  info: window.console.info,
  log: window.console.log,
  warn: window.console.warn,
};

startRetryTimer();

Object.keys(logFunctions).forEach((level) => {
  window.console[level] = (...args) => {
    const stringifiedArgs = stringifyArgs({ args });

    window.api?.logToFile?.([level, ...stringifiedArgs]);

    logToIDB(level, stringifiedArgs);

    const timestamp = `[${new Date().toISOString()}]`;

    args.unshift(timestamp);

    logFunctions[level](...args);
  };
});
